<div class="body">
    <div class="fields">
        <input-field class="description" title="Omschrijving" [value]="_description" (valueChange)="updateDescription($event)"></input-field>
        <div class="input-field">
            <div class="header">Bedrag</div>
            <currency-input class="input" [value]="_amount" (valueChange)="updateAmount($event)" (focus)="_handleFocusAmount()"></currency-input>
        </div>
    </div>
    <div class="footer">
        <div class="btn" (click)="done()">Klaar</div>
    </div>
</div>